import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'gck',
    themes: {
      gck: {
        dark: false,
        colors: {
          primary:    '#1A237E',   // deep indigo
          secondary:  '#F57C00',   // amber-orange
          accent:     '#FFD740',   // gold
          error:      '#B71C1C',
          info:       '#0D47A1',
          success:    '#1B5E20',
          warning:    '#E65100',
          background: '#F4F7FF',
          surface:    '#FFFFFF',
        },
      },
    },
  },
  defaults: {
    VCard: { rounded: 'lg' },
    VBtn:  { rounded: 'lg' },
  },
})
